import { computed, inject, Injectable, linkedSignal } from "@angular/core";
import { EnvironmentService } from "./environment.service";
import { QueryParamService } from "./query-param.service";
import { toSignal } from "@angular/core/rxjs-interop";

@Injectable({
    providedIn: 'root'
})
export class DomainService {
    private queryParamService = inject(QueryParamService);
    private environmentService = inject(EnvironmentService);
    private queryParamDomain$$ = this.queryParamService.getSpecificQueryParam('redirectDomain');
    public redirectDomain$$ = linkedSignal(()=>{
    let defaultDomain = this.environmentService.getDefaultDomain();
     if (!this.environmentService.isProduction()){
       return this.queryParamDomain$$()??defaultDomain;
    }
    return defaultDomain;
    });
}